import { getApiUrl } from '../config/api';
import type { CarFormData } from '../types/car';

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
}

export async function fetchCarData(carId: string): Promise<ApiResponse<CarFormData>> {
  const response = await fetch(getApiUrl(`/api/cars/${carId}`));
  return response.json();
}

export async function updateCar(carId: string, data: CarFormData): Promise<ApiResponse> {
  const response = await fetch(getApiUrl(`/api/cars/${carId}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return response.json();
}

export async function submitCarForm(carId: string, data: CarFormData): Promise<ApiResponse> {
  const response = await fetch(getApiUrl(`/api/cars/${carId}/submit-form`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return response.json();
}
